import { jsx as _jsx } from "react/jsx-runtime";
import { FieldViewType } from "../viewType";
import EnumFieldDetail from "./detail";
export default function EnumFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, moduleName = _a.moduleName;
    return (_jsx(EnumFieldDetail, { fieldName: fieldName, record: record, moduleName: moduleName, viewType: FieldViewType.DETAIL }));
}
